import PropTypes from 'prop-types'

export const referencePropType = PropTypes.oneOfType([
  PropTypes.func,
  PropTypes.shape({ current: PropTypes.any })
])

export default referencePropType
